
import React, {useState, useEffect} from 'react';
import { AppBar, Avatar, Button, Toolbar, Typography } from '@material-ui/core';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';
import useStyles from './styles';
import memories from '../../images/VideoGame.png';



const Navbar = () => {
    const classes = useStyles()
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation(); //access to changes

    const logout = () =>{
        dispatch({type: 'LOGOUT'});
        navigate("/");
        setUser(null);
    };

    useEffect(() => {
        const token = user?.token;

        if(token){
            const decodeToken = decode(token);
            if(decodeToken.exp * 1000 < new Date().getTime()) logout();
        }

        setUser(JSON.parse(localStorage.getItem('profile')));
    }, [location]); //JWT Location used to update on page.

    return (
    
            <AppBar className={classes.appBar} position="static" color="inherit">
                <div className={classes.brandContainer}>
                    <Typography component={Link} to="/" className={classes.heading} variant="h2" align="center">Abel's Favorite Games</Typography>
                    <img className={classes.image} src={memories} alt="memories" height="60" />
                </div>
            <Toolbar className={classes.toolbar}>
                    {user?.result ? (
                        <div className={classes.profile}> 
                            <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt(0)}</Avatar>
                            <Typography className={classes.userName} variant='h6'> {user.result.name} </Typography>
                            <Button variant='contained' className={classes.logout} color="secondary" onClick={logout}>logout</Button>
                        </div>
                    ) : (
                        <Button component={Link} to="/auth" variant="contained" color="primary">Sign In</Button>
                    )}
                </Toolbar>
            </AppBar>

    );
};

export default Navbar;
